import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderService } from '../../Services/loader.service';

@Component({
  selector: 'av-global-loader',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './global-loader.component.html',
  styleUrl: './global-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvGlobalLoaderComponent {
  protected readonly loader = inject(LoaderService);
}
